export enum OutboundScanType {
  tool = 'tool',
  fulfillment = 'fulfillment',
}
